import { GraphQLErrorCode } from '@this+that/constants';

import type { BrainAssertionView } from '../../../models/companyBrain';
import { getGraphQLErrorCode } from '../../../utils/graphqlErrors';

export enum BrainAssertionLoadState {
  LOADING = 'loading',
  READY = 'ready',
  UNAVAILABLE = 'unavailable',
  ERROR = 'error',
}

const ACCESS_DENIED_CODES: ReadonlySet<GraphQLErrorCode> = new Set([
  GraphQLErrorCode.FORBIDDEN,
  GraphQLErrorCode.NOT_FOUND,
  GraphQLErrorCode.UNAUTHORIZED,
]);

interface ResolveBrainAssertionLoadStateParams {
  loading: boolean;
  error: unknown;
  assertion: BrainAssertionView | null | undefined;
  hasIds: boolean;
}

export function resolveBrainAssertionLoadState({
  loading,
  error,
  assertion,
  hasIds,
}: ResolveBrainAssertionLoadStateParams): BrainAssertionLoadState {
  if (!hasIds) {
    return BrainAssertionLoadState.UNAVAILABLE;
  }
  if (assertion) {
    return BrainAssertionLoadState.READY;
  }
  if (loading) {
    return BrainAssertionLoadState.LOADING;
  }
  if (error) {
    const code = getGraphQLErrorCode(error);
    return code && ACCESS_DENIED_CODES.has(code)
      ? BrainAssertionLoadState.UNAVAILABLE
      : BrainAssertionLoadState.ERROR;
  }
  return BrainAssertionLoadState.UNAVAILABLE;
}
